/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookmark: {
  name: 'bookmark';
  data: string;
} = {
  name: 'bookmark',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 2A1.5 1.5 0 0 1 3 .5h10A1.5 1.5 0 0 1 14.5 2v11.538a1.5 1.5 0 0 1-2.044 1.398l-4.275-1.662a.5.5 0 0 0-.362 0l-4.275 1.662A1.5 1.5 0 0 1 1.5 13.538V2ZM3 1.5a.5.5 0 0 0-.5.5v11.538a.5.5 0 0 0 .681.466l4.275-1.662a1.5 1.5 0 0 1 1.088 0l4.275 1.662a.5.5 0 0 0 .681-.466V2a.5.5 0 0 0-.5-.5H3Z" fill="currentColor"/></svg>`,
};
